/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY.
 * See libs/messenger/codegen/generators/typescript.py for more information.
*/
import {
  type DefaultService,
  PingRequest,
  PingResponse,
  ServiceInfoRequest,
  ServiceInfoResponse,
  MessengerMetrics,
  protoMetadata,
} from '../../auto_generated/messenger/messenger';
import type { MessengerNode } from '../../node';

/**
 * Base connector for all services
 * Provides a request wrapper that simplifies making requests to services
 */
export class DefaultConnector implements DefaultService {

  /** Runtime map: method → request/response constructors */
  public static readonly methodMeta = {
    Ping: { requestType: PingRequest, responseType: PingResponse },
    GetServiceInfo: { requestType: ServiceInfoRequest, responseType: ServiceInfoResponse },
  } as const;


  /** Runtime map: topic → message constructor */
  public static readonly topicMeta = {
    __metrics__: { topicType: MessengerMetrics },
  } as const;



  /** Protobuf metadata for runtime schema introspection */
  public static readonly protoMetadata = protoMetadata;

  /**
   * Create a new DefaultConnector
   * @param messengerNode - The MessengerNode instance to use for communication
   * @param serviceKey - The service key for the service
   * @param peerId - Optional peer ID for routing requests
   */
  public constructor(
    protected messengerNode: MessengerNode,
    protected serviceKey: string = 'messenger',
    protected peerId?: string,
  ) {}

  /**
   * Make a request to the service
   * @param method - The method to call
   * @param data - The request data
   * @returns A promise that resolves to the response data
   */
  protected async request<TRequest, TResponse>(
    method: string,
    data: TRequest,
    requestType: any,
    responseType: any,
    timeoutMs?: number,
  ): Promise<TResponse> {
    return this.messengerNode.request(
      this.serviceKey,
      method,
      data,
      requestType,
      responseType,
      timeoutMs,
      this.peerId,
    );
  }

  public getMethodMeta(method: string) {
    return (this.constructor as any).methodMeta?.[method];
  }

  public getTopicMeta(topic: string) {
    return (this.constructor as any).topicMeta?.[topic];
  }

  /**
   * Subscribe to a topic with peer awareness
   */
  protected subscribe<TMessage>(
    topicName: string,
    callback: (message: TMessage) => void,
    messageType: any,
  ): void {
    this.messengerNode.subscribe(
      this.serviceKey,
      topicName,
      callback,
      messageType,
      this.peerId,
    );
  }

  /**
   * Unsubscribe from a topic with peer awareness
   */
  protected unsubscribe(
    topicName: string,
  ): void {
    this.messengerNode.unsubscribe(
      this.serviceKey,
      topicName,
      this.peerId,
    );
  }

  /**
   * Push a message to a sink (N-to-1 fan-in) with peer awareness
   */
  protected pushToSink<TMessage>(
    topicName: string,
    message: TMessage,
    messageType: any,
    clientId?: string,
  ): void {
    this.messengerNode.pushToSink(
      this.serviceKey,
      topicName,
      message,
      messageType,
      this.peerId,
      clientId,
    );
  }


  /**
   * Subscribe to the __metrics__ topic
   * @param callback - Callback function to be called when a message is received
   * @param index - Optional topic index (default "")
   */
  public subscribeTo__metrics__(
    callback: (message: MessengerMetrics) => void,
    index: string = ""
  ): void {
    return this.subscribe(
      `__metrics__/${index}`,
      callback,
      MessengerMetrics
    );
  }

  /**
   * Unsubscribe from the __metrics__ topic
   */
  public unsubscribeFrom__metrics__(index: string = ""): void {
    return this.unsubscribe(
      `__metrics__/${index}`
    );
  }


  /**
   * Calls the Ping method on the service.
   */
  public async Ping(params: PingRequest, timeoutMs?: number): Promise<PingResponse> {
    return this.request<PingRequest, PingResponse>('Ping', params, PingRequest, PingResponse, timeoutMs);
  }

  /**
   * Calls the GetServiceInfo method on the service.
   */
  public async GetServiceInfo(params: ServiceInfoRequest, timeoutMs?: number): Promise<ServiceInfoResponse> {
    return this.request<ServiceInfoRequest, ServiceInfoResponse>('GetServiceInfo', params, ServiceInfoRequest, ServiceInfoResponse, timeoutMs);
  }

  /**
   * Get the connection status of the messenger node
   * @returns True if the messenger node is connected to the registry, false otherwise
   */
  public async GetConnectionStatus(): Promise<boolean> {
    try {
      await this.Ping({});

      return true;
    } catch (error) {
      return false;
    }
  }
}
